const SET_TYPES = (state, types) => {
  state.types = types
}

export default {
  SET_TYPES
}
